// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O-sr","colMin":"styles_colMin__3xVpL"};